export default __webpack_public_path__ + "e1225d08e51a803cc03c169de4a075c8.png";